import { HTMLAttributes } from 'react';
import classnames from 'classnames';
import {
  getFontSizeCx,
  removeSpaceProps,
  getSpaceCx,
  SizeProp,
  SpaceProps,
  WeightProp,
  getFontWeightCx,
} from '../util/cx';

type TypographyProps = HTMLAttributes<
  HTMLHeadingElement | HTMLParagraphElement
> &
  SpaceProps & {
    as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p';
    size?: SizeProp; // TODO: This should prolly be fontSize?
    weight?: WeightProp; // TODO: This should prolly be fontWeight?
  };

const DEFAULT_HEADING_SIZE = 'lg';
const DEFAULT_HEADING_ELEMENT = 'h2';
const DEFAULT_HEADING_WEIGHT = 'semibold';

// TODO: Is this really better than Tailwind?
export function Heading({
  as,
  className: providedClassName = '',
  size: providedSize,
  weight: providedWeight,
  ...props
}: TypographyProps) {
  const Component = as ?? DEFAULT_HEADING_ELEMENT;
  const size = providedSize ?? DEFAULT_HEADING_SIZE;
  const weight = providedWeight ?? DEFAULT_HEADING_WEIGHT;

  const className = classnames(
    providedClassName,
    getFontWeightCx(weight),
    getFontSizeCx(size),
    getSpaceCx(props),
  );

  return <Component className={className} {...removeSpaceProps(props)} />;
}

const DEFAULT_TEXT_SIZE = 'base';
const DEFAULT_TEXT_ELEMENT = 'p';
const DEFAULT_TEXT_WEIGHT = 'normal';

export function Text({ as, size, weight, ...props }: TypographyProps) {
  return (
    <Heading
      as={as ?? DEFAULT_TEXT_ELEMENT}
      size={size ?? DEFAULT_TEXT_SIZE}
      weight={weight ?? DEFAULT_TEXT_WEIGHT}
      {...props}
    />
  );
}
